import comp from "./TheatreModeV2";
export default comp;
